const getConsentStatus = (type: string): boolean => {
  // documentation: https://docs.usercentrics.com/#/frontend-javascript-api
  return window.usercentrics?.getConsents().find((c) => c.dataProcessor === type)?.consentStatus ?? false
}

export default getConsentStatus
